// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.file-name {
  align-self: center;
  font-weight: bold;
}

.file-created-by {
  display: table-row;
  font-weight: initial;
  color: darkgray;
}

.file-type {
  width: 6vh;
  height: 6vh;
  line-height: 6vh;
  border-radius: 50%;
  font-size: 14px;
  color: #0476D9;
  font-weight: bold;
  text-align: center;
  background: lightgray;
}

.file-row {
  margin: 1vh;
}

.file-delete {
  text-align-last: center;
  color: gray;
}

.file-download {
  text-align-last: center;
  color: #0476D9;
}

.file-download:hover {
  cursor: pointer;
  text-decoration: underline;
}

.file-delete:hover {
  cursor: pointer;
  text-decoration: underline;
}

.confirm-delete-modal {
  align-items: flex-start;
}

.confirm-delete-modal-header-text {
  display: inline-flex;
  align-items: end;
}

.confirm-delete-modal-warning-icon {
  color: #fb923c;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
